import { BaseService } from './BaseService';
import { API_ENDPOINTS } from './config';
import { ArtifactRelationship, ArtifactRelationshipList } from '../../types/artifactRelationship';

export class RelationshipService extends BaseService {
  static async getAll(): Promise<ArtifactRelationship[]> {
    const response = await this.get<ArtifactRelationshipList>(
      API_ENDPOINTS.ARTIFACT_RELATIONSHIPS.BASE
    );
    return response.items;
  }

  static async getById(id: string): Promise<ArtifactRelationship> {
    return this.get<ArtifactRelationship>(API_ENDPOINTS.ARTIFACT_RELATIONSHIPS.BY_ID(id));
  }

  static async create(data: Partial<ArtifactRelationship>): Promise<ArtifactRelationship> {
    return this.post<ArtifactRelationship>(API_ENDPOINTS.ARTIFACT_RELATIONSHIPS.BASE, data);
  }

  static async update(
    id: string,
    data: Partial<ArtifactRelationship>
  ): Promise<ArtifactRelationship> {
    return this.put<ArtifactRelationship>(API_ENDPOINTS.ARTIFACT_RELATIONSHIPS.BY_ID(id), data);
  }

  static async delete(id: string): Promise<void> {
    return this.delete(API_ENDPOINTS.ARTIFACT_RELATIONSHIPS.BY_ID(id));
  }

  static async getByArtifactId(artifactId: string): Promise<ArtifactRelationship[]> {
    return this.get<ArtifactRelationship[]>(
      `${API_ENDPOINTS.ARTIFACT_RELATIONSHIPS.BASE}/artifact/${artifactId}`
    );
  }

  // Migration
  static async migrateTransitions(): Promise<void> {
    return this.post<void>(API_ENDPOINTS.MIGRATION.MIGRATE, {});
  }
}
